import * as React from 'react'
import { FunctionComponent } from 'react'
import { SessionCard } from '@react-ui'

export interface SessionCardListMobileProps {
  sessions: any[]
  totalWeekendSessions?: number
}

const SessionCardListMobile: FunctionComponent<SessionCardListMobileProps> = ({
  sessions,
  totalWeekendSessions = 0
}) => {
  if (!sessions.length) {
    return null
  }

  return (
    <div className='flex flex-col gap-4'>
      {sessions.map((session) => (
        <SessionCard
          key={session.id}
          data-qa-name={`session-${session.id}`}
          {...session}
          sessionStatus={session.skipped ? 'skipped' : session.status}
          totalWeekendSessions={totalWeekendSessions}
          isMobile={true}
        />
      ))}
    </div>
  )
}

export default SessionCardListMobile
